import { DialogContent } from "@hireart/component-library";
import clsx from "clsx";
import PropTypes from "prop-types";

export const ModalContent = ({ className = "", ...props }) => (
  <DialogContent {...props} className={clsx("ha-modal-content", className)} />
);

ModalContent.propTypes = {
  className: PropTypes.string,
};
